// extracted by mini-css-extract-plugin
export var component = "NewsletterModule-module--component--Ph2IZ";
export var form = "NewsletterModule-module--form--5M2AN";
export var formInput = "NewsletterModule-module--formInput--vCKhU";
export var header = "NewsletterModule-module--header--TmHo+";
export var isCompact = "NewsletterModule-module--isCompact--D0DLX";
export var preamble = "NewsletterModule-module--preamble--DFx+Q";
export var title = "NewsletterModule-module--title--cMXlY";
export var titleIcon = "NewsletterModule-module--titleIcon--vmRUu";